import { useState } from 'react'
import { Typography, Grid } from '@mui/material'
import Select from '../ui/SelectWithExternalLabel'
import SelectNumber from '../ui/SelectNumber'
import CompanyLogo from '../CompanyLogo'
import { useProject } from '../../context/project'
import Tag from '../ui/Tag'
import ElevationButton from '../ui/ElevationButton'
import DatasetButtonForAlert from '../ui/alternativeData/DatasetButtonWithExternalLabel'
import { commonColors } from '../../utils/constants'
import styles from './Alert.module.scss'

const alertOnOptions = ["-5%","-10%","+5%","+10%", "Custom"]

const SetAlert = ({activeButton, handleChange, change, updateField, fieldName}) => (
    <div>
        <Typography variant="h6" component='label'>Alert On</Typography>
        <div className={`${styles["buttons"]} ${styles["flex"]}`}>
            {alertOnOptions.map((item, i) => 
                <ElevationButton key={item} active={activeButton === item} onClick={handleChange}>
                    {item === 'Custom' ? item : (<p style={{color: i <= 1 ? commonColors.stockDown : commonColors.stockUp }}>{item}</p>)}
                </ElevationButton>)}
            { activeButton === 'Custom' && <SelectNumber value={change} setValue={updateField} fieldName={fieldName}/>}
        </div>
    </div>)

export default function SetAlertPanel({ form, updateField, options, originalFrequency, groupByOptions, datasetButtonProps, alertToEdit, ...props}) {
    const { tickerInfo} = useProject()
    const { ticker, alertType, selectedDataset, change, timePeriod } = form
    const [activeButtons, setActiveButtons] = useState({'change': alertOnOptions.find(option => parseInt(option) === change)})
    const [ addAlert, setAddAlert ] = useState(false)

    const handleChange = (e, fieldName) => {
        const targetValue = e.target.innerText
        setActiveButtons((state) => ({...state, [fieldName]: targetValue}))
        targetValue !== 'Custom' && updateField({value: parseInt(targetValue), name: fieldName})
    }

    const clickAddAlert = () => {
        setActiveButtons((state) => ({...state, 'change_1': "+5%"}))
        updateField({value: 5, name: 'change_1'})
        setAddAlert(true)
    }

    return (
        <>
            <Grid container direction="column" classes={{ root: styles['root'] }}>
                <span className={styles['ticker-info']}>
                    <CompanyLogo image={tickerInfo?.image} ticker={ticker} size={32}/>
                    <Typography variant="h2">{tickerInfo?.companyName}</Typography>
                    <Tag label={ticker}/>
                </span>
                <Select options={options.type} fieldName="alertType" value={alertType} label="Choose Alert Type" setValue={updateField}/>
                <div className={styles['alert-rule']}>Alert Rule</div>
                <div className={styles["grid"]}>
                    <DatasetButtonForAlert {...datasetButtonProps} currentDataset={selectedDataset} {...props}/>
                    <Select options={groupByOptions} fieldName="timePeriod" value={timePeriod || originalFrequency} setValue={updateField} label="For Timeperiod"/>
                </div>
                {selectedDataset.columnValue && <>
                <SetAlert activeButton={activeButtons['change']} handleChange={(e) => handleChange(e, 'change')} change={change} updateField={updateField} fieldName='change'/>
                {!addAlert && !alertToEdit && <button className={styles['add-alert']} onClick={clickAddAlert}>+ Add alert</button>}
                {addAlert && <SetAlert activeButton={activeButtons['change_1']} handleChange={(e) => handleChange(e, 'change_1')} change={form.change_1 || 5} updateField={updateField} fieldName='change_1'/>}
                </>}
            </Grid>
        </>
    )
}